var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 215.7",
    style: {
      enableBackground: "new 0 0 1000 215.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_356_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_428_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_438_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_439_",
    className: "st0",
    d: "M171.9,155.6c-14.3,0-28-4.4-39.6-12.7c-3.4-2.5-4.2-7.2-1.7-10.6c2.5-3.4,7.2-4.2,10.6-1.7 c9,6.5,19.6,9.9,30.7,9.9c24.9,0,46.5-17.6,51.5-42c0.8-4.1,4.9-6.8,9-5.9c4.1,0.8,6.8,4.9,5.9,9 C232,132.8,204,155.6,171.9,155.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_437_",
    className: "st0",
    d: "M115.8,117.2c-3.1,0-5.9-1.8-7.1-4.9c-3-7.8-4.6-16.1-4.6-24.6c0-37.4,30.4-67.8,67.8-67.8 c20.6,0,39.9,9.2,52.8,25.3c2.6,3.3,2.1,8.1-1.2,10.7c-3.3,2.6-8.1,2.1-10.7-1.2c-10-12.5-25-19.6-41-19.6 c-29,0-52.6,23.6-52.6,52.6c0,6.6,1.2,13,3.6,19.1c1.5,3.9-0.4,8.3-4.3,9.9C117.7,117.1,116.8,117.2,115.8,117.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_434_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_435_",
    className: "st0",
    d: "M204.9,105.5c-0.6,0-1.3-0.1-1.9-0.3c-2.8-1-4.3-4.2-3.2-7c2.1-5.5,2.4-11.7,1-17.5 c-3.2-13.4-15.1-22.8-28.8-22.8c0,0,0,0,0,0c-3,0-5.4-2-5.4-5c0-3,2.4-5,5.4-5c0,0,0,0,0,0c18.8,0,35,12.4,39.4,30.7 c1.9,7.9,1.4,15.9-1.4,23.5C209.2,104.3,207.1,105.5,204.9,105.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_431_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_432_",
    className: "st0",
    d: "M171.9,128.4c-7.4,0-14.6-2-21-5.9c-9.3-5.6-15.8-14.5-18.3-25.1 c-2.8-11.6-0.4-23.8,6.6-33.4c1.8-2.4,5.2-3,7.6-1.2c2.4,1.8,3,5.2,1.2,7.6c-5.1,7.1-6.9,16-4.8,24.4c1.9,7.7,6.7,14.1,13.4,18.3 c6.4,4.1,14.4,5.3,22.4,3.5c2.9-0.7,5.9,1.1,6.6,4c0.7,2.9-1.1,5.9-4,6.6C178.3,128,175.1,128.4,171.9,128.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_429_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    className: "st0",
    d: "M171.9,110.8c-2.8,0-5.7-0.5-8.3-1.6c-2.1-0.8-3.1-3.1-2.3-5.2c0.8-2.1,3.2-3.1,5.2-2.3 c2.8,1.1,5.8,1.3,8.7,0.7c3.9-0.9,7.2-3.2,9.3-6.6c2.1-3.4,2.8-7.3,1.9-11.2c-0.9-3.9-3.2-7.2-6.6-9.3c-3.4-2.1-7.4-2.8-11.2-1.9 c-8,1.8-13.1,9.8-11.3,17.8c0.5,2.2-0.9,4.3-3,4.8c-2.2,0.5-4.3-0.9-4.8-3c-2.8-12.3,5-24.7,17.4-27.4c6-1.3,12.1-0.3,17.3,3 c5.2,3.3,8.8,8.4,10.1,14.4c1.3,6,0.3,12.1-3,17.3c-3.3,5.2-8.4,8.8-14.4,10.1C175.3,110.6,173.6,110.8,171.9,110.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_357_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_199_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_221_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_222_",
    className: "st0",
    d: "M686.3,110.6c0-23.7,19.3-42.9,42.9-42.9c23.7,0,42.9,19.1,42.9,42.9 c0,23.6-19.1,42.9-42.9,42.9C705.6,153.5,686.3,134.2,686.3,110.6z M703.2,110.6c0,14.2,11.6,26,26,26c14.3,0,26-11.8,26-26 c0-14.3-11.6-25.9-26-25.9C714.8,84.7,703.2,96.3,703.2,110.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_218_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_219_",
    className: "st0",
    d: "M289.1,144.5V33.3c0-4.6,3.8-8.4,8.5-8.4c4.6,0,8.4,3.8,8.4,8.4v111.1 c0,4.8-3.8,8.5-8.4,8.5C292.8,153,289.1,149.2,289.1,144.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_214_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_215_",
    className: "st0",
    d: "M524.3,144.8v42.5c0,4.6-3.8,8.4-8.4,8.4c-4.8,0-8.5-3.8-8.5-8.4v-76.5v-0.2 c0-23.6,19.3-42.9,42.9-42.9c23.7,0,42.9,19.3,42.9,42.9c0,23.7-19.1,42.9-42.9,42.9C540.6,153.5,531.5,150.3,524.3,144.8z  M524.3,110.7v0.2c0,14.2,11.6,25.8,26,25.8c14.3,0,25.9-11.6,25.9-25.9c0-14.2-11.6-26-25.9-26 C536,84.7,524.3,96.3,524.3,110.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_211_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_212_",
    className: "st0",
    d: "M678,104.7v39.6c0,4.8-3.9,8.5-8.5,8.5c-4.6,0-8.4-3.8-8.4-8.5v-39.6 c0-11.4-9.4-20.7-20.8-20.7c-11.4,0-20.7,9.2-20.7,20.7v39.6c0,4.8-3.8,8.5-8.5,8.5c-4.6,0-8.4-3.8-8.4-8.5V33.1 c0-4.6,3.8-8.4,8.4-8.4c4.8,0,8.5,3.8,8.5,8.4v40.1c6-3.9,13-6.1,20.7-6.1C661.1,67.1,678,84,678,104.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_208_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_209_",
    className: "st0",
    d: "M783,144.5V33.3c0-4.6,3.8-8.4,8.5-8.4c4.6,0,8.4,3.8,8.4,8.4v111.1c0,4.8-3.8,8.5-8.4,8.5 C786.8,153,783,149.2,783,144.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_204_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_205_",
    className: "st0",
    d: "M895.9,110c0,4.6-3.8,8.4-8.5,8.4h-58.9c3.6,10.2,13.1,17.6,24.6,17.6 c3.9,0,10.9-0.3,19.1-5.6c3.9-2.6,9.2-0.2,11.3,3.9c2,4.3-0.2,8.7-4.1,11.3c-11.3,7.5-20,7.3-26.3,7.3 c-23.7,0-42.9-19.3-42.9-42.9c0-23.7,19.1-42.9,42.9-42.9C873.7,67.1,895.9,82.1,895.9,110z M828.4,101.4h49.3 C874.2,89.5,863.3,84,853,84C841.6,84,832,91.4,828.4,101.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_203_",
    className: "st0",
    d: "M360,154c-3.7,0-7.4-0.5-11.1-1.4c-11.4-2.9-20.9-10.1-26.9-20.2c-4.5-7.6-6.6-16.2-6-25 c0.3-4.5,4.2-8,8.7-7.7c4.5,0.3,8,4.2,7.7,8.7c-0.3,5.5,1,10.9,3.8,15.7c3.7,6.3,9.7,10.8,16.9,12.7c7.1,1.8,14.6,0.8,20.9-3 c6.3-3.7,10.8-9.7,12.7-16.9c1.8-7.1,0.8-14.6-3-20.9c-3.7-6.3-9.7-10.8-16.9-12.7c-7.1-1.8-14.6-0.8-20.9,3 c-3.9,2.3-8.9,1-11.2-2.9c-2.3-3.9-1-8.9,2.9-11.2c10.1-6,22-7.6,33.3-4.7c11.4,2.9,20.9,10.1,26.9,20.2c6,10.1,7.6,22,4.7,33.3 c-2.9,11.4-10.1,20.9-20.2,26.9C375.4,152,367.7,154,360,154z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_201_",
    className: "st0",
    d: "M449.9,153.7c-0.3,0-0.7,0-1-0.1c-24.1-3-41.2-25-38.2-49.1c3-24.1,25-41.2,49.1-38.2 c24.1,3,41.2,25,38.2,49.1c-1.1,8.7-4.7,16.9-10.5,23.5c-3,3.4-8.2,3.8-11.6,0.8c-3.4-3-3.8-8.2-0.8-11.6 c3.6-4.1,5.9-9.2,6.6-14.7c1.9-15.1-8.9-28.9-23.9-30.8c-15.1-1.9-28.9,8.9-30.8,23.9c-1.9,15.1,8.9,28.9,23.9,30.8 c4.5,0.6,7.7,4.7,7.1,9.2C457.6,150.7,454,153.7,449.9,153.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLogoWhite);
export default __webpack_public_path__ + "static/media/horizontalLogoWhite.85ce6d720bb3aa5d7f539de08b30423e.svg";
export { ForwardRef as ReactComponent };